import React, { useState, useEffect } from "react";
import SignIn from "./SignIn/SignIn";
import VerifyCode from "./VerifyCode/VerifyCode";

function Auth({ onAuthenticated }) {
  const [step, setStep] = useState("signin"); // 'signin' or 'verify'
  const [verificationData, setVerificationData] = useState(null);

  // Check for existing token on mount
  useEffect(() => {
    const token = localStorage.getItem("JWT");
    if (token) {
      // Verify token is not expired
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const expiry = payload.exp * 1000;
        if (Date.now() < expiry && payload.customer) {
          onAuthenticated(token);
          return;
        }
      } catch (e) {
        // Invalid token format, clear it
        localStorage.removeItem("JWT");
      }
    }
  }, [onAuthenticated]);

  const handleVerificationSent = (data) => {
    setVerificationData(data);
    setStep("verify");
  };

  const handleVerificationSuccess = (token) => {
    localStorage.setItem("JWT", token);
    onAuthenticated(token);
  };

  const handleBackToSignIn = () => {
    setStep("signin");
    setVerificationData(null);
  };

  if (step === "verify" && verificationData) {
    return (
      <VerifyCode
        verificationData={verificationData}
        onSuccess={handleVerificationSuccess}
        onBack={handleBackToSignIn}
      />
    );
  }

  return <SignIn onVerificationSent={handleVerificationSent} />;
}

export default Auth;



